import { render } from "./navbar.vue?vue&type=template&id=60366ab8&ts=true"
import script from "./navbar.vue?vue&type=script&lang=ts"
export * from "./navbar.vue?vue&type=script&lang=ts"

import exportComponent from "/geosite/web/geosite-de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__